<div>
    <!--Dietary Needs--> 
    <h4>{{ 'copy.label.ATTENDEE.DIETARY.header' | copy | async }}</h4>
    <div [innerHTML]="'copy.html.WashingtonHealthLaw ' |copy |async | safeHtml"></div>
    <div class="w-100 required">
        <label for="DietaryNeed" aria-labelledby="DietaryNeed">{{ 'copy.label.FEATURES.DIETARY.label' | copy | async }}</label>
    </div>
    <div class="w-100" >
        <div *ngFor="let meal of mealList">
            <div class="agreeCheckbox">
                <div class="checkboxFlexContainer">
                    <mat-checkbox *ngIf="meal.name !== 'Other' && meal.name !== 'Food Allergy'" name="meal_{{ meal.name }}_{{guest.$mtcUUID}}" [ngModel]="guest.DietaryConsiderations.includes(meal.name)" (change)="mealUpdate(guest, meal)" aria-labelledby="{{ meal.code }}_label" [required]="!hasdietary(guest)"></mat-checkbox>
                    <mat-checkbox *ngIf="meal.name === 'Other'" name="meal_{{ meal.name }}_{{guest.$mtcUUID}}" [(ngModel)]="guest.$mtcdietaryOtherCheckbox" (change)="mealUpdate(guest, meal)" aria-labelledby="{{ meal.code }}_label" [required]="!hasdietary(guest)"></mat-checkbox>
                    <mat-checkbox *ngIf="meal.name === 'Food Allergy'" name="meal_{{ meal.name }}_{{guest.$mtcUUID}}" [(ngModel)]="guest.$mtcallergyCheckbox" (change)="mealUpdate(guest, meal)" aria-labelledby="{{ meal.code }}_label" [required]="!hasdietary(guest)"></mat-checkbox>
                    <label id="{{ meal.code }}_label">{{ meal.name }}</label>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="guest.$mtcShowDietaryDescription">
        <mat-form-field class="w-100">
            <mat-label for="dietDesc" aria-labelledby="dietDesc">
                {{ 'copy.label.FEATURES.PERSONAL.considerationDescription' | copy | async }}</mat-label>
            <mat-select name="dietDesc_{{guest.$mtcUUID}}" id="dietDesc_{{guest.$mtcUUID}}" aria-label="dietDesc" [(ngModel)]="dietaryDescription.Value"
                matNativeControl required>
                <mat-option *ngFor="let obj of considerationReasonList" [value]="obj.name">{{ obj.name }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div *ngIf="dietaryDescription.Value === 'Other'">
        <div class="d-flex justify-content-start" >
            <mat-form-field class="w-100">
                <mat-label for="considerationDescriptionOther" aria-labelledby="considerationDescriptionOther">
                    {{ 'copy.label.FEATURES.PERSONAL.considerationDescriptionOther' | copy | async }}</mat-label>
                    <textarea matInput class="w-100" name="considerationDescriptionOther_{{guest.$mtcUUID}}" id="considerationDescriptionOther_{{guest.$mtcUUID}}"
                    aria-label="Consideration Description Other" [(ngModel)]="guest.$mtcDietaryDescriptionOther"
                    maxlength="225" required pattern="^[\w\s!@\-\_:',.\/?]*" #considerationDescriptionOther="ngModel"></textarea>
                    <mat-error><app-validation [object]="considerationDescriptionOther" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="w-100" *ngIf="guest.$mtcdietaryOtherCheckbox === true || guest.$mtcallergyCheckbox === true">
        <div class="d-flex justify-content-start">
            <mat-form-field class="w-100">
            <mat-label for="DietaryConsiderations">{{ 'copy.label.FEATURES.DIETARY.otherlabel' | copy | async }}</mat-label>
            <textarea matInput class="w-100" name="DietaryConsiderations_{{guest.$mtcUUID}}" id="DietaryConsiderations_{{guest.$mtcUUID}}" aria-label="DietaryConsiderations" [(ngModel)]="guest.$mtcmealOther" (keypress)="removeExclamation($event)" #DietaryConsiderations="ngModel" maxlength="125" pattern="^[\w\s!@\-\_:',.\/?]*" required></textarea>
            <mat-error><app-validation  [object]="DietaryConsiderations" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
        </div>
    </div>
    <mat-error *ngIf="hasdietary(guest) === false && guest.$mtcshowguestselecterror">{{ 'copy.label.ATTENDEE.adaError' | copy | async }}</mat-error>
    
    <!--ADA/Personal-->
    <div class="w-100 required">
        <label for="DietaryNeed" aria-labelledby="DietaryNeed">{{ 'copy.label.FEATURES.PERSONAL.heading' | copy | async }}</label>
    </div>
    <div class="w-100">
        <div *ngFor="let considerations of personalConsiderationsList">
            <div class="agreeCheckbox">
                <div class="checkboxFlexContainer">
                    <mat-checkbox name="considerations_{{ considerations.name }}_{{guest.$mtcUUID}}"
                    [ngModel]="includes(guest.DisabilityType,considerations.code)"
                    (change)="considerationUpdate(considerations,guest)" [required]="!haspersonalconsiderations(guest)" matNativeControl>
                    </mat-checkbox>
                    <label>{{ considerations.name }}</label>
                </div>
            </div>
            <!-- {{personalConsiderations.invalid}} -->
        </div>
    </div>
    <div *ngIf="includes(guest.DisabilityType, 'OTHER')">
        <div class="d-flex justify-content-start" >
            <mat-form-field class="w-100">
                <mat-label for="PersonalConsiderations" aria-labelledby="PersonalConsiderations">
                    {{ 'copy.label.FEATURES.PERSONAL.otherlabel' | copy | async }}</mat-label>
                    <textarea matInput class="w-100" name="PersonalConsiderations_{{guest.$mtcUUID}}" id="PersonalConsiderations_{{guest.$mtcUUID}}"
                    aria-label="PersonalConsiderations" [(ngModel)]="guest.PersonalConsiderations"
                    maxlength="225"  [required]="includes(guest.DisabilityType, 'OTHER')" pattern="^[\w\s!@\-\_:',.\/?]*" #PersonalConsiderations="ngModel"></textarea>
                    <mat-error><app-validation [object]="PersonalConsiderations" isRequired=true pattern="alphanum"></app-validation></mat-error>
            </mat-form-field>
        </div>
    </div>
    <mat-error *ngIf="haspersonalconsiderations(guest) === false && guest.$mtcshowguestselecterror">{{ 'copy.label.ATTENDEE.adaError' | copy | async }}</mat-error>

    <div class="w-100 required">
        <br/>
        <label class="w-100" for="adaSeating" aria-labelledby="adaSeating">
        <span [innerHTML]="'copy.label.GUEST.adaSeatingLabel'|copy|async"></span>
        </label>
        <mat-radio-group class="w-100" [(ngModel)]="adaSeating.Value" name="adaSeatingValue_{{guest.$mtcUUID}}" #adaSeatingValue="ngModel" required>
        <mat-radio-button value="Yes">Yes</mat-radio-button>
        <mat-radio-button value="No">No</mat-radio-button>
        <mat-error><app-validation [object]="adaSeatingValue" isRequired="true"></app-validation></mat-error>
        </mat-radio-group>  
    </div>
</div>
